const getTopDomain = (): string => {
  const domain = window.location.hostname;
  const parts = domain.split('.');
  return parts.slice(-2).join('.');
};

export default getTopDomain;
